import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  breadcrumbAriaLabel: {
    id: 'portal.views.cohortCreate.breadcrumb.ariaLabel',
    defaultMessage: 'Breadcrumb',
    description: 'Accessible label for the breadcrumb navigation landmark',
  },
  breadcrumbCohorts: {
    id: 'portal.views.cohortCreate.breadcrumb.cohorts',
    defaultMessage: 'Cohorts',
    description: 'Breadcrumb link back to the Cohorts landing page',
  },
  breadcrumbCreated: {
    id: 'portal.views.cohortCreate.breadcrumb.created',
    defaultMessage: 'Cohort created',
    description: 'Third breadcrumb crumb shown on the cohort-created success screen',
  },
  successBannerSubtitle: {
    id: 'portal.views.cohortCreate.success.bannerSubtitle',
    defaultMessage: 'Your cohort is ready. Share the invite link below to get your group started.',
    description: 'Secondary line inside the success banner on the cohort-created screen',
  },
  inviteLinkHelp: {
    id: 'portal.views.cohortCreate.success.inviteLinkHelp',
    defaultMessage: 'Share this link with your group. When they click it, they’ll be taken directly to a page where they can join your cohort.',
    description: 'Helper paragraph under the Invite Link heading on the success screen',
  },
  breadcrumbCreate: {
    id: 'portal.views.cohortCreate.breadcrumb.create',
    defaultMessage: 'Create a Cohort',
    description: 'Breadcrumb label for the current Create a Cohort page',
  },
  pageTitle: {
    id: 'portal.views.cohortCreate.title',
    defaultMessage: 'Create a New Cohort',
    description: 'Create a Cohort page title',
  },
  pageSubtitle: {
    id: 'portal.views.cohortCreate.subtitle',
    defaultMessage: 'Set up a group for your team, class, or community to go through the course together.',
    description: 'Subtitle shown under the Create a New Cohort page title',
  },
  restrictedMessage: {
    id: 'portal.views.cohortCreate.restricted',
    defaultMessage: 'This page is only available to facilitators.',
    description: 'Message shown to non-facilitators who navigate to the Create a Cohort page',
  },
  backToCohortsLink: {
    id: 'portal.views.cohortCreate.backLink',
    defaultMessage: 'Back to Cohorts',
    description: 'Link back to the Cohorts landing page',
  },
  nameLabel: {
    id: 'portal.views.cohortCreate.field.name.label',
    defaultMessage: 'Cohort Name',
    description: 'Cohort name field label',
  },
  namePlaceholder: {
    id: 'portal.views.cohortCreate.field.name.placeholder',
    defaultMessage: 'e.g. London Leadership Group',
    description: 'Cohort name field placeholder',
  },
  descriptionLabel: {
    id: 'portal.views.cohortCreate.field.description.label',
    defaultMessage: 'Description',
    description: 'Cohort description field label',
  },
  descriptionPlaceholder: {
    id: 'portal.views.cohortCreate.field.description.placeholder',
    defaultMessage: 'Tell members what this cohort is about (optional)',
    description: 'Cohort description field placeholder',
  },
  requiredNameError: {
    id: 'portal.views.cohortCreate.field.name.required',
    defaultMessage: 'Cohort name is required.',
    description: 'Validation error for an empty cohort name',
  },
  submitError: {
    id: 'portal.views.cohortCreate.submit.error',
    defaultMessage: 'We could not create your cohort. Please check the form and try again.',
    description: 'Generic error message when cohort creation fails',
  },
  createButton: {
    id: 'portal.views.cohortCreate.button.create',
    defaultMessage: 'Create Cohort',
    description: 'Create Cohort submit button',
  },
  creatingButton: {
    id: 'portal.views.cohortCreate.button.creating',
    defaultMessage: 'Creating…',
    description: 'Create Cohort submit button while the request is pending',
  },
  cancelButton: {
    id: 'portal.views.cohortCreate.button.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button, returns to My Cohorts',
  },
  successBanner: {
    id: 'portal.views.cohortCreate.success.banner',
    defaultMessage: 'Cohort Created Successfully!',
    description: 'Success banner shown after creating a cohort',
  },
  inviteLinkLabel: {
    id: 'portal.views.cohortCreate.success.inviteLinkLabel',
    defaultMessage: 'Invite Link',
    description: 'Label for the read-only invite link field',
  },
  copyLinkButton: {
    id: 'portal.views.cohortCreate.success.copyLink',
    defaultMessage: 'Copy Link',
    description: 'Copy Link button',
  },
  copiedLinkButton: {
    id: 'portal.views.cohortCreate.success.copiedLink',
    defaultMessage: 'Copied!',
    description: 'Copy Link button feedback after a successful copy',
  },
  whatHappensTitle: {
    id: 'portal.views.cohortCreate.success.whatHappensTitle',
    defaultMessage: 'What happens when someone clicks the link?',
    description: 'Heading for the 3-step explanation of the invite link',
  },
  whatHappensStep1: {
    id: 'portal.views.cohortCreate.success.whatHappensStep1',
    defaultMessage: 'They see your cohort’s name, description, and member count.',
    description: 'Step 1 of the what-happens-when-someone-clicks-the-link explanation',
  },
  whatHappensStep2: {
    id: 'portal.views.cohortCreate.success.whatHappensStep2',
    defaultMessage: 'If they are not logged in, they are asked to log in or register first.',
    description: 'Step 2 of the what-happens-when-someone-clicks-the-link explanation',
  },
  whatHappensStep3: {
    id: 'portal.views.cohortCreate.success.whatHappensStep3',
    defaultMessage: 'Once they join, they are automatically enrolled in the cohort’s courses.',
    description: 'Step 3 of the what-happens-when-someone-clicks-the-link explanation',
  },
  goToMyCohortsButton: {
    id: 'portal.views.cohortCreate.success.goToMyCohorts',
    defaultMessage: 'Go to My Cohorts →',
    description: 'Button that navigates to the My Cohorts page after creating a cohort',
  },
});

export default messages;
